<template>
  <DetailTemplate :custom-class="'ticket-detail detail-page'" v-if="getPermission('visit:view')">
    <template v-slot:sidebar-detail>
      <div class="mt-5">
        <table width="100%">
          <tr>
            <td valign="top" class="py-1 font-size-18 font-weight-500" width="80">
              Total Visit
            </td>
            <td valign="middle" class="py-1 font-size-18 font-weight-500">
              <label class="m-0 font-weight-700">
                <v-badge color="red" class="ml-1" :content="detail.ticketVisitCount"></v-badge>
              </label>
            </td>
          </tr>
          <tr>
            <td valign="top" class="py-1 font-size-18 font-weight-500" width="80">
              Overnight
            </td>
            <td valign="middle" class="py-1 font-size-18 font-weight-500">
              <label class="m-0 font-weight-700">
                <v-chip label :color="detail.is_multi_day == 1 ? 'green' : 'red'" text-color="white" small>
                  <template v-if="detail.is_multi_day == 1">

                    Yes
                  </template>
                  <template v-else>
                    No
                  </template>
                </v-chip>

              </label>
            </td>
          </tr>
          <tr>
            <td valign="top" class="py-1 font-size-18 font-weight-500">
              Customer
            </td>
            <td valign="middle" class="py-1 font-size-18 font-weight-500">
              <router-link v-if="detail && detail.customer && detail.customer.id" :to="getDefaultRoute('customer.detail', {
                params: {
                  id: detail.customer.id,
                },
              })
                ">
                {{ detail.customer.display_name }}
              </router-link>
              <em v-else class="text-muted"> no Customer</em>
            </td>
          </tr>
          <tr>
            <td valign="top" class="py-1 font-size-18 font-weight-500">
              Reference #
            </td>
            <td valign="middle" class="py-1 font-size-18 font-weight-500">
              <label class="m-0" v-if="detail && detail.reference">{{
                detail.reference
              }}</label>
              <em v-else class="text-muted"> no refernce </em>
            </td>
          </tr>
          <!-- <tr>
            <td valign="top" class="py-1 font-size-18 font-weight-500">
              Appointment
            </td>
            <td valign="middle" class="py-1 font-size-18 font-weight-500">
              <span
                style="color: #24326d !important"
                v-html="getAppointmentText"
              >
              </span>
            </td>
          </tr> -->
          <tr>
            <td valign="middle" class="py-1 font-size-18 font-weight-500">
              Priority
            </td>
            <td valign="middle" class="py-1 font-size-18 font-weight-500">
              <Priority v-if="detail && detail.priority" class="my-1 ml-n2" :priority="detail.priority" small>
              </Priority>
              <em v-else class="text-muted"> no Priority</em>
            </td>
          </tr>

          <tr v-if="detail.schedule_message">
            <td valign="top" class="py-1 font-size-18 font-weight-500">
              Schedule
            </td>
            <td valign="middle" class="py-1 font-size-18 font-weight-500">
              <label class="m-0">{{ detail.schedule_message }}</label>
            </td>
          </tr>

          <tr>
            <td valign="top" class="py-1 font-size-18 font-weight-500">Tag</td>
            <td valign="middle" class="py-1 font-size-18 font-weight-500">
              <template v-if="detail?.tags?.length">
                <v-chip v-for="(row, index) in detail.tags" :key="index" class="mr-1 mb-1" text-color="white" small
                  label :color="row.color">
                  <span class="">
                    {{ row.text }}
                  </span>
                </v-chip>
              </template>
              <em v-else class="text-muted"> no tags</em>
            </td>
          </tr>
        </table>
      </div>

      <div class="mt-5">
        <v-flex md12>
          <table width="100%">
            <tr>
              <th colspan="2" class="cyan lighten-4 font-size-16 text-uppercase color-custom-blue py-1">
                Contact details
              </th>
            </tr>
            <tr v-if="detail.billing_person">
              <td width="60px" class="font-size-18 font-weight-500 py-1">
                Name
              </td>
              <td class="py-1 font-size-18">
                <template v-if="
                  detail &&
                  detail.billing_person &&
                  detail.billing_person.display_name
                ">
                  {{ detail.billing_person.display_name }}
                </template>
                <em v-else class="text-muted"> no name</em>
              </td>
            </tr>
            <tr v-if="detail.billing_person">
              <td class="font-size-18 font-weight-500 py-1">Phone</td>
              <td class="py-1 font-size-18">
                <template v-if="
                  detail &&
                  detail.billing_person &&
                  detail.billing_person.primary_phone
                ">
                  {{ detail.billing_person.primary_phone }}
                </template>
                <em v-else class="text-muted"> no phone</em>
              </td>
            </tr>
            <tr v-if="detail.billing_person">
              <td class="font-size-18 font-weight-500 py-1">Email</td>
              <td class="py-1 font-size-18">
                <template v-if="
                  detail &&
                  detail.billing_person &&
                  detail.billing_person.primary_email
                ">
                  {{ detail.billing_person.primary_email }}
                </template>
                <em v-else class="text-muted"> no email</em>

              </td>
            </tr>
            <tr>
              <th class="py-1"></th>
            </tr>
            <tr>
              <th colspan="2" class="cyan lighten-4 font-size-16 text-uppercase color-custom-blue py-1">
                Site Location
              </th>
            </tr>
            <tr v-if="
              detail && detail.property && detail.property.property_address
            ">
              <td colspan="2" class="py-0 font-size-18 font-weight-500 py-2">
                <template v-if="detail?.property?.id">
                  <span> <!--   <v-icon small>mdi-map-marker</v-icon>--></span>
                  <p class="mr-2" v-if="detail?.property">
                    <span v-if="detail?.property?.property_name">{{ detail?.property?.property_name }}<br /></span>

                    {{ detail?.property?.street_1 }},
                    <br v-if="
                      detail?.property?.street_2 || detail?.property?.unit_no
                    " />
                    <template v-if="detail?.property?.street_2">
                      {{ detail?.property?.street_2 }},
                    </template>
                    <template v-if="detail?.property?.unit_no">
                      {{ detail?.property?.unit_no }},
                    </template>
                    <br />
                    {{ detail?.property?.country }}
                    <template v-if="
                      detail?.property &&
                      detail?.property?.zip_code != '000000'
                    ">
                      , {{ detail?.property?.zip_code }}
                    </template>
                  </p>
                </template>
                <!--  <a
                  target="_blank"
                  :href="`https://maps.google.com/?q=${detail.property.property_address}`"
                  >{{ detail.property.property_address }}</a
                > -->
              </td>
            </tr>

          </table>
        </v-flex>
      </div>
      <table width="100%">
        <tr>
          <th class="cyan lighten-4 font-size-16 text-uppercase color-custom-blue py-1">
            Billing Address
          </th>
        </tr>
        <tr v-if="detail && detail.billing && detail.billing.property_address">
          <td class="py-0 font-size-18 font-weight-500 pt-2">
            <template v-if="detail?.billing?.id">
              <span> <!--   <v-icon small>mdi-map-marker</v-icon>--></span>
              <p class="mr-2" v-if="detail?.billing">
                <span v-if="detail?.billing?.property_name">{{ detail?.billing?.property_name }}<br /></span>
                {{ detail?.billing?.street_1 }},
                <br v-if="detail?.billing?.street_2 || detail?.billing?.unit_no" />
                <template v-if="detail?.billing?.street_2">
                  {{ detail?.billing?.street_2 }},
                </template>
                <template v-if="detail?.billing?.unit_no">
                  {{ detail?.billing?.unit_no }},
                </template>
                <br />
                {{ detail?.billing?.country }}
                <template v-if="
                  detail?.billing && detail?.billing?.zip_code != '000000'
                ">
                  , {{ detail?.billing?.zip_code }}
                </template>
              </p>
              <em v-else class="text-muted"> no address</em>
            </template>
            <!--  <a
                                    target="_blank"
                                    :href="`https://maps.google.com/?q=${detail.billing.property_address}`"
                                    >{{ detail.billing.property_address }}</a
                                  > -->
          </td>
        </tr>
      </table>
    </template>
    <template v-slot:header-title>
      <h1 class="form-title custom-nowrap-ellipsis text-capitalize mr-2 font-weight-700" v-if="detail && detail.title">
        <!--  Trip: -->
        {{ detail.barcode }} / {{ detail.title }}
      </h1>
      <!-- </v-chip> -->
    </template>

    <template v-slot:header-action>
      <div class="d-flex align-center justify-end flex-wrap" v-if="pageLoaded">
        <v-chip min-height="30" class="mr-2 mb-1 font-weight-600 text-uppercase" label color="red" text-color="white">
          Recurring Job
        </v-chip>
        <v-btn depressed class="mx-2 mb-1 custom-grey-border custom-bold-button" v-on:click="goBack()">
          <v-icon small left>mdi-keyboard-backspace</v-icon>
          Back
        </v-btn>
      </div>
    </template>
    <template v-slot:body>

      <v-container fluid class="">
        <v-row v-if="pageLoaded">
          <v-col md="12" class="py-0">
            <v-tabs active-class="custom-tab-active" v-model="ticketTab" background-color="transparent" color="cyan"
              class="custom-tab-transparent tab-sticky cyan lighten-4" show-arrows>
              <v-tab class="font-size-16 font-weight-600 px-8" href="#recurring">
                <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
                  <!--begin::Svg Icon-->
                  <inline-svg :src="$assetURL('media/custom-svg/line-item.svg')" />
                  <!--end::Svg Icon-->
                </span>
                Recurring Job
              </v-tab>
              <v-tab class="font-size-16 font-weight-600 px-8" href="#other">
                <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
                  <!--begin::Svg Icon-->
                  <inline-svg :src="$assetURL('media/custom-svg/visit.svg')" />
                  <!--end::Svg Icon-->
                </span>
                Other Information
              </v-tab>

              <v-tab class="font-size-16 font-weight-600 px-8" href="#history">
                <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
                  <!--begin::Svg Icon-->
                  <inline-svg :src="$assetURL('media/custom-svg/history.svg')" />
                  <!--end::Svg Icon-->
                </span>
                History
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="ticketTab">
              <v-tab-item value="recurring">
                <VisitInternalAll :detail="detail" type="ticket" :ticket-id="detail.id" hide-action
                  :visit-count="detail.ticketVisitCount" v-on:detail-recrring="getVisit()"></VisitInternalAll>
              </v-tab-item>
              <v-tab-item value="other">
                <v-container fluid class="px-0">
                  <v-row>
                    <v-col md="6">
                      <v-card flat class="custom-grey-border remove-border-radius mb-4 h-100">
                        <v-card-title class="headline cyan lighten-4 py-1">
                          <span class="font-weight-700 custom-headline color-custom-blue font-size-16 Information">
                            Information</span>
                        </v-card-title>
                        <v-card-text class="p-6 font-size-16">
                          <v-flex md12>
                            <table width="100%">
                              <tr>
                                <td valign="middle" class="py-1 font-size-18 font-weight-500">
                                  PO Number
                                </td>
                                <td align="center">:</td>
                                <td valign="middle" class="py-1 font-size-18 font-weight-500">
                                  <label class="m-0">
                                    <template v-if="detail.po_number">
                                      {{ detail.po_number }}</template>
                                    <em v-else class="text-muted">
                                      no po number</em>
                                  </label>
                                </td>
                              </tr>
                              <tr>
                                <td valign="middle" class="py-1 font-size-18 font-weight-500">
                                  Payment Mode
                                </td>
                                <td align="center">:</td>
                                <td valign="middle" class="py-1 font-size-18 font-weight-500">
                                  <template v-if="
                                    detail.payment_mode &&
                                    detail.payment_mode.text
                                  ">
                                    {{ detail.payment_mode.text }}</template>
                                  <em v-else class="text-muted">
                                    no Payment Mode</em>
                                </td>
                              </tr>
                              <tr>
                                <td valign="top" class="py-1 font-size-18 font-weight-500">
                                  Job Type
                                </td>
                                <td align="center">:</td>
                                <td valign="middle" class="py-1 font-size-18 font-weight-500">
                                  <v-tooltip v-for="(type, index) in detail.ticket_type" :key="'ticket-type' + index"
                                    top content-class="custom-top-tooltip">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-chip v-bind="attrs" v-on="on" class="mr-2 font-weight-600"
                                        color="chip-custom-blue" label small outlined>
                                        {{ type }}
                                      </v-chip>
                                    </template>
                                    <span>Job Type</span>
                                  </v-tooltip>
                                </td>
                              </tr>

                            </table>
                          </v-flex>
                        </v-card-text>
                      </v-card>
                    </v-col>

                  </v-row>
                  <v-card flat class="custom-grey-border remove-border-radius mb-4">
                    <v-card-title class="headline cyan lighten-4 py-1">
                      <span
                        class="font-weight-700 custom-headline color-custom-blue font-size-16 text-uppercase">Notes</span>
                    </v-card-title>
                    <v-card-text class="p-6 font-size-16">
                      <v-layout class="mb-4">
                        <v-flex md6 class="custom-border-right">
                          <v-card-title class="headline cyan lighten-5 py-1">
                            <span class="font-weight-700 custom-headline color-custom-blue font-size-16">Client Note
                            </span>
                          </v-card-title>
                          <read-more class="mx-4 custom-read-more font-weight-600 font-size-18 pb-1 custom-gray-color"
                            more-str="read more" :text="detail.client_remark || '<em>no Client Note</em>'
                              " link="#" less-str="read less" :max-chars="200">
                          </read-more>
                        </v-flex>
                        <v-flex md6>
                          <v-card-title class="headline cyan lighten-5 py-1">
                            <span class="font-weight-700 custom-headline color-custom-blue font-size-16">Admin
                              Note</span>
                            <v-spacer></v-spacer>
                            <span class="d-flex" style="
                                margin-top: -3px !important;
                                font-size: 14px !important;
                              ">
                            </span>
                          </v-card-title>

                          <read-more class="mx-4 custom-read-more font-weight-600 font-size-18 pb-1 custom-gray-color"
                            more-str="read more" :text="detail.admin_remark || '<em>No Admin Note </em>'
                              " link="#" less-str="read less" :max-chars="200">
                          </read-more>
                        </v-flex>
                      </v-layout>

                    </v-card-text>
                  </v-card>
                </v-container>
              </v-tab-item>
              <v-tab-item :value="'history'">
                <InternalHistoryDetail type="job" :type_id="detail.id"></InternalHistoryDetail>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </DetailTemplate>
</template>
<script>
import moment from "moment-timezone";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import CommonMixin from "@/core/plugins/common-mixin";
import DetailTemplate from "@/view/pages/partials/Detail-Template.vue";
import ValidationMixin from "@/core/plugins/validation-mixin";
import VisitInternalAll from "@/view/pages/partials/Detail/VisitInternalAll.vue";
import InternalHistoryDetail from "@/view/pages/partials/Detail/Internal-History-Detail.vue";
import { mapGetters } from "vuex";

import {
  GET,
} from "@/core/services/store/request.module";
import Priority from "@/view/pages/partials/Priority.vue";
import JobRequestMixin from "@/core/lib/job/api.request.job.mixin";

import {
  toSafeInteger,

} from "lodash";

import { currentUser } from "@/core/services/jwt.service";
/* import Barcode from "@/view/pages/partials/Barcode.vue"; */

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  mixins: [
    CommonMixin,
    ValidationMixin,
    JobRequestMixin,
    // CreateTicketCloserMixin,
  ],
  data() {
    return {
      yourFormat: "hh:mm A",
      ticketId: 0,
      pageLoading: false,
      pageLoaded: false,
      detail: {
        term_conditions: null,
      },
    };
  },
  methods: {


    getVisit() {
      this.$store
        .dispatch(GET, { url: "ticket/t1/" + this.ticketId })
        .then(({ data }) => {


          this.detail = data.ticket;

          this.ticket = data.ticket;
          this.paymentmodes = data.resultpayment_modes;
          if (this.detail.accept_term == 1) {
            this.detail.accept_term = true;
          }
          if (this.detail.accept_term == 0) {
            this.detail.accept_term = false;
          }

          this.ticketId = this.detail && this.detail.id ? toSafeInteger(this.detail.id) : 0;

          this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Recurring Job", route: "recurring-job" },
            { title: "Detail" },
            { title: this.detail.barcode },
          ]);
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.pageLoaded = true;

        });
    },


  },
  created() {
    this.ticketId =
      this.$route && this.$route.params && this.$route.params.id
        ? toSafeInteger(this.$route.params.id)
        : 0;
  },
  mounted() {
    this.getVisit();

  },
  beforeDestroy() {

  },
  computed: {
    ...mapGetters(["vAvailableTeam"]),
    is_staff() {
      const user = currentUser();
      const role_name = this.lodash.toLower(user.role_name);
      return role_name == "admin";
    },
    is_staff_login() {
      const user = currentUser();
      const role_engineer = this.lodash.toLower(user.engineer);

      return role_engineer == role_engineer;
    },

    /*  getAppointmentText() {
       if (isEmpty(this.visit) === false) {
         let date = this.formatDate(this.detail?.started_at);
         let startTime = moment(this.detail?.started_at).format("hh:mm A");
         let enddate = this.formatDate(this.detail?.finished_at);
         let endTime = moment(this.detail?.finished_at).format("hh:mm A");
         return `<div>From - ${date} ${startTime} </div>
                 <div>To&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; - ${enddate} ${endTime} </div>`;
       }
       return null;
     }, */

    ticketTab: {
      set(val) {
        let query = { ...this.$route.query };
        query.tab = val;
        if (val != this.ticketTab) {
          this.$router.push({ query });
        }
      },
      get() {
        return this.$route.query.tab || "recurring";
      },
    },
  },
  components: {
    Priority,
    DetailTemplate,
    InternalHistoryDetail,
    /* Barcode, */
    VisitInternalAll,
  },
};
</script>
